import React, { useState } from 'react';
import { exportTxt, exportCsv } from '../utils/exportCards';

export default function Export() {
  const [status, setStatus] = useState(null); // null | 'exporting' | 'done'
  const [lastFormat, setLastFormat] = useState(null);

  const handleExport = async (fn, format) => {
    setStatus('exporting');
    setLastFormat(format);
    await fn();
    setStatus('done');
  };

  return (
    <div style={{ maxWidth: 600 }}>
      <div className="page-header">
        <h1>Export</h1>
        <div className="subtitle">Download all your active cards.</div>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
        <button
          className="btn btn-primary"
          onClick={() => handleExport(exportTxt, '.txt')}
          disabled={status === 'exporting'}
          style={{ fontSize: '1rem', padding: '0.75rem 1.5rem', textAlign: 'left' }}
        >
          Export as .txt — cards only
        </button>
        <button
          className="btn btn-secondary"
          onClick={() => handleExport(exportCsv, '.csv')}
          disabled={status === 'exporting'}
          style={{ fontSize: '1rem', padding: '0.75rem 1.5rem', textAlign: 'left' }}
        >
          Export as .csv — cards and tags, for backup
        </button>
      </div>

      {status === 'done' && (
        <p style={{ marginTop: '1rem', color: 'var(--text-muted)', fontFamily: 'sans-serif', fontSize: '0.9rem' }}>
          {lastFormat} file downloaded.
        </p>
      )}
    </div>
  );
}
